import React from 'react';

const SearchBox = ({
  styleName, placeholder, onChange, value, onButtonClick, onKeyPress,
}) => {
  return (
    <div className={`search-bar left-side-icon bg-transparent ${styleName}`}>
      <div className="form-group">
        <input
          className="form-control input-for-search border-0"
          type="search"
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          onKeyPress={onKeyPress}
        />
        <button className="search-icon" onClick={onButtonClick}><i className="zmdi zmdi-search zmdi-hc-lg" />
        </button>
      </div>
    </div>
  );
};
export default SearchBox;

SearchBox.defaultProps = {
  styleName: '',
  value: '',
};



// WEBPACK FOOTER //
// ./components/SearchBox/index.js